import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=662d6e44&scoped=true&"
import script from "./LogsView.vue?vue&type=script&lang=js&"
export * from "./LogsView.vue?vue&type=script&lang=js&"
import style0 from "./LogsView.vue?vue&type=style&index=0&id=662d6e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d6e44",
  null
  
)

export default component.exports